<template>
    <section>
        <h4>Set up your new Wireless device</h4>
        <p>Follow the steps below to get your <span v-html="provider"></span> SIM + Device up and running.</p>

        <div class="divider"></div>
        <div class="config-steps">
            <config-step v-for="step in steps" :step="step"></config-step>
<!--            <div class="config-step">-->
<!--                <ul>-->
<!--                    <li>Remove the modem from the box.</li>-->
<!--                    <li>Carefully push out the correct size SIM for your device.</li>-->
<!--                    <li>Insert the SIM into the modem. Make sure the SIM faces the right direction.</li>-->
<!--                    <li>Plug the modem into a wall socket and switch it on.</li>-->
<!--                </ul>-->
<!--            </div>&lt;!&ndash; end.config-step &ndash;&gt;-->
        </div><!-- end.config-steps -->
        <p class="foot-note">Your services should be active within 30 minutes, but may take up to 48 hours.</p>
        <section-footer
            :buttons="buttons"
            @next="startOver()">
        </section-footer>
    </section>
</template>

<script>
    import ConfigStep from '@/components/ConfigStep'
    import SectionFooter from '@/components/SectionFooter'

    export default {
        components: {
            ConfigStep,
            SectionFooter,
        },
        computed: {
            provider() {
                let provider = this.$store.getters['provider'];
                return provider === 'pure-lte' ? 'Pure&nbsp;Wireless' : 'Telkom';
            },
            buttons() {
                return [
                    {
                        label: 'Start Again',
                        event: 'next',
                        class: '',
                        disabled: false
                    }
                ]
            }
        },
        methods: {
            startOver() {
                this.$store.commit('reset');
                this.$router.push({name: 'home'});
            }
        },
        data() {
            return {
                steps: [
                    {
                        title: 'Set up your device',
                        steps: [
                            {
                                content: 'Remove the modem from the box.',
                                subSteps: false
                            },
                            {
                                content: 'Carefully push out the correct size SIM for your device.',
                                subSteps: false
                            },
                            {
                                content: 'Insert the SIM into the modem. Make sure the SIM faces the right direction.',
                                subSteps: false
                            },
                            {
                                content: 'Plug the modem into a wall socket and switch it on.',
                                subSteps: false
                            }
                        ]
                    }
                ]
            }
        }
    }
</script>